var finansudd = finansudd || {};

finansudd.servicelist = new function() {

	var self = this;

	this.initServices = function() {
		if ($("#service-list").length) {
			self.loadService(1,0);
			self.changeFilter(1, 0);
		}

		if ($("#service-slider").length){
			self.loadServiceSlider(1, 0);
		}
	}

	this.loadService = function (page,val) {
		var maxitems = 0
		var subjectAreas = val;

		if (val == 0) {
			subjectAreas = $(".service-wrapper").data("subjectarea");
		}
		
		var subjectAreasArray = subjectAreas != undefined ? subjectAreas.split(",").clean("") : null;

		var filterValues = JSON.stringify({
			"SelectedPage": page,
			"maxItems": maxitems,
			"SubjectAreas": subjectAreasArray
		});
		
		$.ajax({
			url: "/settings/servicelistview/", // TODO: Change this to the right url
			type: 'POST',
			cache: false,
			contentType: "html/text; charset=utf-8",
			dataType: 'html',
			data: filterValues,
			success: function(data) {
				var itemCount = $(data).siblings('.item-count').text();
				$('.ajax-filter .filter-count > span').html(itemCount);

				$("#service-list").html(data)
			
				self.paging();

				novicell.responsiveImages.init();
			},
			error: function (data, errorThrown) {
				console.log(errorThrown)
				$("#service-list").html('<div class="ajax-content error-msg">Der er desværre sket en fejl </br></br> <button class="btn btn-blue light" onclick="location.reload();"> Genindlæs siden </button></div>');
			}
		});
	}

	this.loadServiceSlider = function (page, val) {
		var maxitems = 0
		var subjectAreas = val;

		if (val == 0) {
			subjectAreas = $(".service-wrapper").data("subjectarea");
		}

		var subjectAreasArray = subjectAreas != undefined ? subjectAreas.split(",").clean("") : null;

		var filterValues = JSON.stringify({
			"Page": page,
			"maxItems": maxitems,
			"Mode":"slider",
			"SubjectAreas": subjectAreasArray
		});

		$.ajax({
			url: "/settings/servicelistview/", // TODO: Change this to the right url
			type: 'POST',
			cache: false,
			contentType: "html/text; charset=utf-8",
			dataType: 'html',
			data: filterValues,
			success: function (data) {
				
				$("#service-slider").html(data)
			
				finansudd.slider.newsSlider($('#service-slider'));
				novicell.responsiveImages.init();
			},
			error: function (data, errorThrown) {
				console.log(errorThrown)
			}
		});
	}

	this.changeFilter = function (page) {
		$(".service-filter-select").change(function() {
			self.loadService(page, $(this).val());
		});
		
	}

	this.paging = function () {

		$(".pager").click(function (e) {
			e.preventDefault();
			self.loadService($(this).data("page"));
		});

	}

	Array.prototype.clean = function (deleteValue) {
		for (var i = 0; i < this.length; i++) {
			if (this[i] == deleteValue) {
				this.splice(i, 1);
				i--;
			}
		}
		return this;
	};
}